import * as types from './constants';

const initialState = {
};
const pagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TOGGLE_EDITOR:
      return {
        ...state
      };

    default: return state;
  }
};

export default pagesReducer;
